import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSingle_multiLevel_selector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template";
import {sidebarMenu_template} from "./sidebarMenu_template";

declare var ko: any;

const stripe = Stripe('pk_live_51QtwVaGBQMFmh3BoDciuLnLpLRGUkbY8MyV6d5Cl2ugVBowYPhIQApLwc7N6K19ksFaQVxmVpGrixPplGDKqXiXT00TrvUehDi'); // Replace with your Stripe public key

const appearance = {
    base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
    },
    invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
    },
    rules: {
      '.Input': {
        borderColor: 'red',
        borderWidth: '2px',
        borserStyle: 'solid',
        boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02)',
    },

      // See all supported class names and selector syntax below
    }
  };

const elements = stripe.elements();
const card = elements.create('card');

export class subscriptionManagement_template extends vnTemplate {

    protected plan: filterSingle_multiLevel_selector_template;
    public sidebarMenu: sidebarMenu_template;

    readonly plans = [
        {"id": 2, "name": "essential"},
        {"id": 3, "name": "advanced"},
        {"id": 4, "name": "pro"}
    ];

    protected getTemplateHtml(): string{

        return `
            <div class="page-header">
                <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
                <h2 style="display: none;" class="title-page">Subscription-Management</h2>
            </div>

            <div class="nav-page-container">
                <div class="nav-page-grid">

                    <div class="nav-page-sidebar">
                        ` + this.sidebarMenu.getHtmlBuild() + `
                    </div>

                    <div class="nav-page-content ">
                        <div class="block-default variation">
                            <div class="w-justify full-width">
                                <div class="w-left w-form">
                                    <div class="form-body form-body-header">
                                        <div class="form-group">
                                            <span class="form-sub-title">
                                                Plan Details & Billing
                                            </span>
                                        </div>
                                        <div class="form-group">
                                            <p class="form-text">
                                                View available plans and upgrade your account to unlock more features and higher usage limits.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-right">

                                 </div>
                            </div>
                        </div>

                        <div class="w-form form-setting w-form-large promo-style is-hidden" data-bind="css: {'is-visible' : showManageSubscription()}" style="margin: 0 !important;">
                            <div class="form-header short" style="width: 100%;"></div>
                            <div class="w-form-body">
                                <div class="form-body form-body-header block-filters">
                                    <div class="form-group">
                                        <span class="form-sub-title icon i-membership" style="padding-left: 0;">
                                            My Plan
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <hr class="form-hr margin">
                                    </div>
                                    <div class="w-pricing-container form-group" >

                                        <!-- ko if: currPlanId() == 2 -->
                                        <div class="pricing-card">
                                            <h3>Essential</h3>
                                            <hr>
                                            <ul>
                                                <li><strong><span>up to 10M hits per month</span></strong></li>
                                                <li><strong><span>Long Term Data</span></strong></li>
                                                <li><strong><span>API</span></strong></li>
                                                <li><span>Unlimited features</span></li>
                                                <li><span>Unlimited properties</span></li>
                                                <li class="no-before" style="display: none;"><span>label</span><hr></li>
                                                <li><span>Exports</span></li>
                                                <li><span>Custom events</span></li>
                                            </ul>
                                        </div>
                                        <!-- /ko -->

                                        <!-- ko if: currPlanId() == 3 -->
                                        <div class="pricing-card">
                                            <h3>Advanced</h3>
                                            <hr>
                                            <ul>
                                                <li><strong><span>up to 50M hits per month</span></strong></li>
                                                <li><strong><span>Long Term Data</span></strong></li>
                                                <li><strong><span>API</span></strong></li>
                                                <li><span>Unlimited features</span></li>
                                                <li><span>Unlimited properties</span></li>
                                                <li><span>Exports</span></li>
                                                <li><span>Custom events</span></li>

                                            </ul>
                                        </div>
                                        <!-- /ko -->

                                        <!-- ko if: currPlanId() == 4 -->
                                        <div class="pricing-card">
                                            <h3>Pro</h3>
                                            <hr>
                                            <ul>
                                                <li><strong><span>up to 100M hits per month</strong></li>
                                                <li><strong><span>Long Term Data</span></strong></li>
                                                <li><strong><span>API</span></strong></li>
                                                <li><span>Unlimited features</span></li>
                                                <li><span>Unlimited properties</span></li>
                                                <li><span>Exports</span></li>
                                                <li><span>Custom events</span></li>
                                            </ul>
                                        </div>
                                        <!-- /ko -->
                                    </div>
                                </div>

                                <div class="form-body extra-padding">
                                    <hr class="form-hr only-mobile margin">
                                    <div class="form-group">
                                        <span class="form-sub-title icon i-task-group" style="padding-left: 0;">
                                            Upgrade Plan
                                        </span>
                                    </div>

                                    <div class="form-group">
                                        <hr class="form-hr margin">
                                    </div>

                                     <div class="form-group">
                                        <a data-bind="attr: {href: sessionUrl()}" target="_blank" class="btn">Upgrade my plan</a>
                                    </div>

                                    <div class="form-group">
                                        <hr class="form-hr margin">
                                    </div>

                                    <div class="form-group">
                                        <p>By subscribing to this service, you agree to recurring payments as per your selected plan. You can cancel your subscription at any time through your account settings, and your access will remain active until the end of the billing period.</p>
                                    </div>

                                </div>
                            </div>

                            <div class="w-form-body" style="width: 100%;">
                                <div class="form-body sub-footer full-width">
                                    <div class="form-group">
                                        <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                        <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="w-form form-setting w-form-large promo-style is-hidden" data-bind="css: {'is-visible' : showCheckout()}" style="margin: 0 !important;">
                            <div class="form-header short" style="width: 100%;"></div>
                            <div class="w-form-body">
                                <div class="form-body form-body-header block-filters">
                                    <div class="form-group">
                                        <span class="form-sub-title icon i-task-group" style="padding-left: 0;">
                                            Upgrade Plan
                                        </span>
                                    </div>
                                    <div class="form-group row" style="width: fit-content;justify-content: flex-start;gap: 2rem;">
                                        <label for="plan" class="form-label">Plan</label>
                                        ` + this.plan.getHtmlBuild() + `
                                    </div>
                                    <div class="form-group">
                                        <hr class="form-hr margin">
                                    </div>
                                    <div class="w-pricing-container form-group" >
                                        <!-- ko if: planId() == 2 -->
                                        <div class="pricing-card">
                                            <h3>Essential</h3>
                                            <div class="price" data-bind="html: calculatePrice()"></div>
                                            <br>
                                            <ul>
                                                <li><strong><span>up to 10M hits per month</span></strong></li>
                                                <li><strong><span>Long Term Data</span></strong></li>
                                                <li><strong><span>API</span></strong></li>
                                                <li><span>Unlimited features</span></li>
                                                <li><span>Unlimited properties</span></li>
                                                <li class="no-before" style="display: none;"><span>label</span><hr></li>
                                                <li><span>Exports</span></li>
                                                <li><span>Custom events</span></li>
                                            </ul>
                                        </div>
                                        <!-- /ko -->

                                        <!-- ko if: planId() == 3 -->
                                        <div class="pricing-card">
                                            <h3>Advanced</h3>
                                            <div class="price" data-bind="html: calculatePrice()"></div>
                                            <hr>
                                            <ul>
                                                <li><strong><span>up to 50M hits per month</span></strong></li>
                                                <li><strong><span>Long Term Data</span></strong></li>
                                                <li><strong><span>API</span></strong></li>
                                                <li><span>Unlimited features</span></li>
                                                <li><span>Unlimited properties</span></li>
                                                <li><span>Exports</span></li>
                                                <li><span>Custom events</span></li>

                                            </ul>
                                        </div>
                                        <!-- /ko -->

                                        <!-- ko if: planId() == 4 -->
                                        <div class="pricing-card">
                                            <h3>Pro</h3>
                                            <div class="price" data-bind="html: calculatePrice()"></div>
                                            <hr>
                                            <ul>
                                                <li><strong><span>up to 100M hits per month</strong></li>
                                                <li><strong><span>Long Term Data</span></strong></li>
                                                <li><strong><span>API</span></strong></li>
                                                <li><span>Unlimited features</span></li>
                                                <li><span>Unlimited properties</span></li>
                                                <li><span>Exports</span></li>
                                                <li><span>Custom events</span></li>
                                            </ul>
                                        </div>
                                        <!-- /ko -->
                                    </div>

                                </div>



                                <div class="form-body extra-padding">
                                    <hr class="form-hr only-mobile margin">
                                    <div class="form-group">
                                        <span class="form-sub-title icon i-credit"  style="padding-left: 0;">
                                            payment info
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <label for="billingEmail" class="form-label">Email</label>
                                        <input id="billingEmail" data-bind="value: billingEmail" type="email" class="input-text" style="margin-bottom: .3rem;">
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">Card Details</label>
                                        <div id="card-element" class="feild-border"></div>
                                        <p class="form-text error" data-bind="visible: message(),text: message">revre</p>
                                    </div>

                                    <div class="form-group">
                                        <label for="promoCode" class="form-label">Promo Code</label>
                                        <input id="promoCode" data-bind="visible: promoCodeId() == '', value: promoCode" type="input" class="input-text" style="margin-bottom: .3rem;">
                                        <p class="form-text" data-bind="visible: promoCodeId() !== '',text: promoCodeDescription"></p>
                                        <button class="btn dark full" type="button" data-bind="attr: { style: promoCodeId() == '' ? 'display: inline-block' : 'display: none !important;' }, event: { click: onClickApplyPromo}">Apply</button>
                                        <button class="btn dark full" type="button" data-bind="attr: { style: promoCodeId() !== '' ? 'display: inline-block' : 'display: none !important;' }, event: { click: onClickRemovePromo}">Remove</button>
                                        <p class="form-text error" data-bind="visible: promoCodeMessage(),text: promoCodeMessage"></p>
                                    </div>

                                    <div class="form-group">
                                        <hr class="form-hr margin">
                                    </div>

                                    <div class="form-group">
                                        <p>By subscribing to this service, you agree to recurring payments as per your selected plan. You can cancel your subscription at any time through your account settings, and your access will remain active until the end of the billing period.</p>
                                    </div>

                                </div>
                            </div>


                            <div class="form-footer" style="padding: 1rem;width: 100%;">
                                <button class="btn dark full" type="button" data-bind="event: { click: onClickPaidSignUpAction}">Process Payment</button>
                            </div>


                            <div class="w-form-body" style="width: 100%;">
                                <div class="form-body sub-footer full-width">
                                    <div class="form-group">
                                        <p class="form-text">Have any questions or need help?<br>Our support team is always happy to assist!<br />
                                        <a href="mailto:support@sentinelpro.com">support@sentinelpro.com</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                </div>
            </div>

            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>

            <div class="w-lightbox light-theme center" data-bind="css: {'is-visible' : showPaymentConfirmation()}">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Upgrade Successful</h3>
                            <button type="button" data-bind="event: { click: onCloseConfirmationPopup }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">Your subscription has been upgraded. You now have access to additional features and higher usage limits.</p>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button data-bind="event: { click: onCloseConfirmationPopup }" type="button" class="btn highlight">Ok</button>
                        </div>
                    </div>

                </div>
            </div>

            `;
    }

    protected getTemplateName(): string{
        return "signup_template";
    }

    protected initPartial(): void{

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('subscription-management');

        this.plan = new filterSingle_multiLevel_selector_template('plan', this.getTemplateViewModel(), this.caller);
    }

    protected getMainElementClasses(): Array<string>{
        return ["page-content"];
    }

    public initCardElement() {

        card.mount('#card-element');
    }


    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            currPlanId: ko.observable(),
            planId: ko.observable(2),
            planPrices: ko.observableArray([
                { id: '2', price: 299 },
                { id: '3', price: 699 },
                { id: '4', price: 999 }
            ]),
            paymentMethodId: ko.observable(""),
            billingEmail: ko.observable(""),
            message: ko.observable(""),
            promoCode: ko.observable(""),
            promoCodeId: ko.observable(""),
            promoCodeType: ko.observable(""),
            promoCodeAmount: ko.observable(""),
            promoCodeDescription: ko.observable(""),
            promoCodeMessage: ko.observable(""),
            sessionUrl: ko.observable(""),
            showCheckout: ko.observable(false),
            showPaymentConfirmation: ko.observable(false),
            showManageSubscription: ko.observable(false),
            onClickPaidSignUpAction: function(data, event){huit_neuf_this.onClickPaidSignUpAction();},
            openSidebar: function(){huit_neuf_this.openSidebar();},
            onCloseConfirmationPopup: function(){huit_neuf_this.onCloseConfirmationPopup();},
            onClickApplyPromo: function(data, event){ return huit_neuf_this.onClickApplyPromo(); },
            onClickRemovePromo: function(data, event){ return huit_neuf_this.onClickRemovePromo(); },
            calculatePrice: function(){return ko.computed(function () { return huit_neuf_this.calculatePrice();}, this)},
        };
    }

    public getViewModelForRequest(): Object{

        return {
            billingEmail: this.getTemplateViewModel().billingEmail(),
            plan: this.plan.getSelectedOption(),
            paymentMethodId: this.getTemplateViewModel().paymentMethodId(),
            promoCode: this.getTemplateViewModel().promoCode(),
            promoCodeId: this.getTemplateViewModel().promoCodeId(),
        };
    }

    protected onClickPaidSignUpAction(){

        if (!this.isValidEmail(this.getTemplateViewModel().billingEmail())) {

            this.getTemplateViewModel().message('Error: Invalid Email');
        }else {

            stripe.createPaymentMethod({
                type: 'card',
                card: card,
            }).then((result) => {

                if (result.error) {
                    // Handle error

                    this.getTemplateViewModel().message('Error: ' + result.error.message);
                } else {

                    this.getTemplateViewModel().paymentMethodId(result.paymentMethod.id);
                    this.caller.checkout();
                }
            });
        }
    }

    public initPlans() {

        this.plan.setGroups(this.plans.map(p => {

            return {
                id: p.id,
                name: p.name,
                type: '',
                cssClasses: ''
            }
        }));

        this.updatePlanId();

    }

    public updatePlanId() {

        this.getTemplateViewModel().planId(this.plan.getSelectedOption());
        console.log(this.getTemplateViewModel().planId());
    }

    public setSideMenuPermissionsData(data){

        this.sidebarMenu.setData(data);
    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }

    private onCloseConfirmationPopup(){

        this.caller.onCloseConfirmationPopup();
    }

    private isValidEmail(email: string) {

        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    protected onClickApplyPromo(){

        this.getTemplateViewModel().promoCodeMessage('');
        this.caller.applyPromo();
    }

    protected onClickRemovePromo(){

        let data = {
            "id" : "",
            "type" : "",
            "amount" : "",
            "description" : "",
            "message" : "",
        };

        this.getTemplateViewModel().promoCode('');
        this.setPromoCodeData(data);
    }

    public setPromoCodeData($data) {

        this.getTemplateViewModel().promoCodeId($data.id);
        this.getTemplateViewModel().promoCodeType($data.type);
        this.getTemplateViewModel().promoCodeAmount($data.amount);
        this.getTemplateViewModel().promoCodeDescription($data.description);
        this.getTemplateViewModel().promoCodeMessage($data.message);
    }

    public calculatePrice() {

        let map = {};
        this.getTemplateViewModel().planPrices().forEach(plan => {
            map[plan.id] = plan.price;
        });

        let planPrice = map[this.getTemplateViewModel().planId()];

        if (this.getTemplateViewModel().promoCodeId !== '') {

            let promoCodeAmount = this.getTemplateViewModel().promoCodeAmount();

            if (this.getTemplateViewModel().promoCodeType() == 'percent_off') {

                planPrice = planPrice - (planPrice * (promoCodeAmount / 100));
            }

            if (this.getTemplateViewModel().promoCodeType() == 'amount_off') {

                planPrice = planPrice - promoCodeAmount;
            }

            planPrice = (planPrice % 1 === 0) ? planPrice : planPrice.toFixed(2);
        }
        return "$" + planPrice + "<small> USD/mo</small>";
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/subscriptionManagement_template.ts